import type { ProgramEventListType } from 'models';
import { useCallback } from 'react';

type P = {
  event: {
    allDay?: boolean;
    endTime: Date;
    startTime: Date;
    type: ProgramEventListType;
  };
};

export const useGetEventTimeInfo = () =>
  useCallback(({ event }: P) => {
    switch (event.type) {
      case 'call':
      case 'clinical_review':
      case 'conference':
      case 'telehealth_visit':
      case 'video_conference':
      case 'webinar':
        return {
          dateFrom: event.startTime,
          dateTo: event.endTime,
        };
      case 'reminder':
        return event.allDay
          ? {
              date: event.startTime,
            }
          : {
              dateTime: event.startTime,
            };
    }
  }, []);
